import React from 'react';
import IconSearch from '@views/static/search.svg';
import { EMPTY_STATE } from '../../intl';
import EmptyStateComponent from '@views/components/emptystate';

export const EmptyState = () => (
  <EmptyStateComponent
    icon={<IconSearch />}
    title={EMPTY_STATE.TITLE}
    message={EMPTY_STATE.MESSAGE}
  />
);

export default EmptyState;
